import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { EqmsScopeManagementComponent } from './eqms-scope-management/eqms-scope-management.component';
import { SharedModule } from '../shared/shared.module';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { FieldsetModule } from 'primeng/fieldset';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ScopeFormSliderComponent } from './scope-form-slider/scope-form-slider.component';
import { UpdateScopeHierarchySliderComponent } from './update-scope-hierarchy-slider/update-scope-hierarchy-slider.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { TreeSelectModule } from 'primeng/treeselect';
import { DialogModule } from 'primeng/dialog';
import { MessagesModule } from 'primeng/messages';
import { ScopeAuditModalComponent } from './scope-audit-modal/scope-audit-modal.component';
import { ScopeAuditTrialComponent } from './scope-audit-trial/scope-audit-trial.component';
import { ScopeAuditSummaryComponent } from './scope-audit-summary/scope-audit-summary.component';
import { BulkUserScopeSliderComponent } from './bulk-user-scope-slider/bulk-user-scope-slider.component';

@NgModule({
  declarations: [
    EqmsScopeManagementComponent,
    ScopeFormSliderComponent,
    UpdateScopeHierarchySliderComponent,
    ScopeAuditModalComponent,
    ScopeAuditTrialComponent,
    ScopeAuditSummaryComponent,
    BulkUserScopeSliderComponent
  ], 
  providers: [ConfirmationService, MessageService],
  imports: [
    CommonModule,
    HttpClientModule,
    SharedModule,
    TooltipModule,
    ButtonModule,
    ReactiveFormsModule,
    FormsModule,
    BptDropdownModule,
    BptTextInputModule,
    CheckboxModule,
    InputTextModule,
    FieldsetModule,
    ConfirmDialogModule,
    ToastModule,
    SpinnerComponent,
    TreeSelectModule,
    DialogModule,
    MessagesModule
  ]
})
export class EqmsScopeModule { }
